import React, {useCallback, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import {TextField, IconButton} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import {formValidations} from "../CVTemplate";
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import OrangeSwitch from "../../OrangeSwitch";
import {Countries} from "./CountryCityConstants";
import GoogleMapsAutocomplete from "../../Jobs/GoogleMapsAutoComplete";
import FormControl from "@mui/material/FormControl";

const EmploymentType = [
    {
        value: "",
        label: "Select employment type",
    },
    {
        value: "Full time employed",
        label: "Full time employed",
    },
    {
        value: "Part-time employed",
        label: "Part-time employed",
    },
    {
        value: "Unemployed",
        label: "Unemployed",
    },
    {
        value: "Self-employed",
        label: "Self-employed",
    },
    {
        value: "Student",
        label: "Student",
    },
    {
        value: "Volunteer",
        label: "Volunteer",
    },
    {
        value: "Other",
        label: "Other",
    },
];
const WorkModel = [
    {
        value: "",
        label: "Select work model",
    },
    {
        value: "On-site",
        label: "On-site",
    },
    {
        value: "Remote",
        label: "Remote",
    },
    {
        value: "Hybrid",
        label: "Hybrid",
    },
];
const IndustryType = [
    {
        value: "",
        label: "Select industry type",
    },
    {
        value: "Finance",
        label: "Finance",
    },
    {
        value: "Education",
        label: "Education",
    },
    {
        value: "Government",
        label: "Government",
    },
    {
        value: "Information Technology",
        label: "Information Technology",
    },
    {
        value: "Media and Entertainment",
        label: "Media and Entertainment",
    },
    {
        value: "Retail",
        label: "Retail",
    },
    {
        value: "Banking",
        label: "Banking",
    },
    {
        value: "Technology",
        label: "Technology",
    },
];

export default function Experience({experience, updateCV, userHasClickedNext, readOnly}) {
    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
    };

    const [key, setKey] = useState(0);
    const [formData, setFormData] = useState(experience);
    const [counter, setCounter] = useState(formData?.length || 1);
    const [requiredData] = useState({
        employerName: experience.employerName,
        jobTitle: experience.jobTitle,
        roleDescription: experience.roleDescription,
        startDate: experience.startDate,
        workModel: experience.workModel,
        employmentType: experience.employmentType,
        industryType: experience.industryType,
        technologiesUsed: experience.technologiesUsed,
        country: experience.country,
        city: experience.city,
    });
    const isCurrentCheckedAnywhere = formData.some(entry => entry.current);

    const isGraduateChecked = formData.some(entry => entry.graduate);
    const [isGraduate, setIsGraduate] = useState(isGraduateChecked);

    const handleChange = async (e, index) => {
        let {name, value} = e.target;
        if (name === "graduate" || name === "current") {
            setFormData((prevFormData) => {
                const newFormData = [...prevFormData];
                newFormData[index] = {
                    ...newFormData[index],
                    [name]: e.target.checked,
                };
                updateCV('experience', newFormData);
                return newFormData;
            });
            setIsGraduate(name === "graduate" && e.target.checked);
        } else {
            setFormData((prevFormData) => {
                const newFormData = [...prevFormData];
                newFormData[index] = {
                    ...newFormData[index],
                    [name]: value,
                };
                updateCV('experience', newFormData);
                return newFormData;
            });
        }
    };

    const handlePlaceSelected = (formattedLocation, index) => {
        const value = formattedLocation ? formattedLocation : '';
        handleChange({
            target: { name: 'city', value: value }
        }, index);
    };

    const checkReqData = useCallback(() => {
        for (let i = 0; i < formData.length; i++) {
            if (formData[i].graduate) {
                formValidations[3].valid = true;
                return;
            } else {
                formValidations[3].valid = false;
            }
        }
        formValidations[3].valid = false

        let result = formData.map((data) => {
            let newData = {...requiredData};
            for (let key in requiredData) {
                if (data.hasOwnProperty(key)) {
                    newData[key] = data[key];
                }
            }
            return newData;
        })

        for (let i = 0; i < result.length; i++) {
            if (result[i] && !Object.values(result[i]).every(value => !!value)) {
                formValidations[3].valid = false;
                return
            } else if ((formData[i].endDate === "" || formData[i].endDate === null) && !formData[i].current) {
                formValidations[3].valid = false;
                return
            }
        }

        formValidations[3].valid = true;

    }, [requiredData, formData])

    useEffect(() => {
        checkReqData();
    }, [formData, checkReqData]);

    const addExperience = () => {
        setCounter(counter + 1);
        setFormData((prevFormData) => [
            ...prevFormData,
            {
                employerName: "",
                jobTitle: "",
                roleDescription: "",
                startDate: "",
                endDate: "",
                current: "",
                workModel: "",
                employmentType: "",
                industryType: "",
                technologiesUsed: "",
                country: "",
                city: ""
            }
        ]);
    }

    const deleteExperience = (index) => {
        setFormData((prevFormData) => {
            const newFormData = [...prevFormData];
            newFormData.splice(index, 1); // Remove the last item
            setKey((prevKey) => prevKey + 1);
            updateCV('experience', newFormData);
            checkReqData();
            setCounter((prevCounter) => prevCounter - 1); // Decrease the counter
            return newFormData;
        });
    };

    return (
        <Grid container direction="row" spacing={2} padding={2}>
            <Grid item xs={12}>
                <h2 data-testid="HeadingExperience">Experience</h2>
            </Grid>

            <Grid item xs={12}>
                <FormControlLabel
                    control={<OrangeSwitch/>}
                    label="I have no work experience"
                    labelPlacement="start"
                    data-testid="graduate"
                    id="graduate"
                    checked={formData[0]?.graduate}
                    onChange={e => handleChange(e, 0)}
                    name="graduate"
                />
            </Grid>

            <Box className={isGraduate ? 'd-none' : 'd-block'} component="section" data-testid="experienceSection">
                {Array.from(Array(counter)).map((c, index) => {
                    const currentFormData = formData[index];
                    return (<Grid key={1} container direction="row" spacing={2} padding={2} justifyContent="flex-start"
                                  alignContent="center">
                        <Grid item xs={7.25}>
                            <h4>Company {index + 1}:</h4>
                        </Grid>

                        <Grid item xs={1}>
                            {counter > 1 ? (
                                <IconButton hidden={readOnly} data-testid={`delete${index}`} onClick={() => {
                                    deleteExperience(index)
                                }} style={{
                                    color: '#FF6600',
                                }}><DeleteIcon/></IconButton>
                            ) : (
                                <IconButton hidden={readOnly} disabled={true} style={{
                                    color: '#808080',
                                }}><DeleteIcon/></IconButton>
                            )}

                        </Grid>

                        <Grid item xs={8}>
                            <TextField label="Employer name"
                                       sx={style}
                                       style={{width: "99%"}}
                                       name="employerName"
                                       required
                                       variant={readOnly ? "standard" : "outlined"}
                                       error={userHasClickedNext && !currentFormData.employerName}
                                       value={currentFormData?.employerName || ''}
                                       data-testid="employerName"
                                       onChange={e => handleChange(e, index)}>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>

                        <Grid item xs={8}>
                            <TextField label="Job title"
                                       sx={style}
                                       style={{width: "99%"}}
                                       name="jobTitle"
                                       required
                                       variant={readOnly ? "standard" : "outlined"}
                                       error={userHasClickedNext && !currentFormData.jobTitle}
                                       value={currentFormData?.jobTitle || ''}
                                       data-testid="jobTitle"
                                       onChange={e => handleChange(e, index)}>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>

                        <Grid item xs={8}>
                            <TextField label="Role description and responsibilities"
                                       multiline={true}
                                       sx={style}
                                       style={{width: "99%"}}
                                       name="roleDescription"
                                       required
                                       variant={readOnly ? "standard" : "outlined"}
                                       error={userHasClickedNext && !currentFormData.roleDescription}
                                       value={currentFormData?.roleDescription || ''}
                                       data-testid="roleDescription"
                                       onChange={e => handleChange(e, index)}>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>
                        <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker label={"Start Date"}
                                            sx={style}
                                            format="DD/MM/YYYY"
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    variant: readOnly ? "standard" : "outlined",
                                                    error: userHasClickedNext && !currentFormData.startDate,
                                                    inputProps: {"data-testid": "experienceStartDate"}
                                                }
                                            }}
                                            style={{width: "99%"}}
                                            key={key}
                                            maxDate={dayjs(currentFormData?.endDate)}
                                            onChange={(newValue) => handleChange({
                                                target: {
                                                    name: "startDate",
                                                    value: newValue
                                                }
                                            }, index)}
                                            defaultValue={dayjs(currentFormData?.startDate || '')}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker label={"End Date"}
                                            sx={style}
                                            format="DD/MM/YYYY"
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    variant: readOnly ? "standard" : "outlined",
                                                    error: !readOnly && userHasClickedNext && !currentFormData.endDate && !currentFormData.current,
                                                    inputProps: {"data-testid": "experienceEndDate"}
                                                }
                                            }}
                                            style={{width: "99%"}}
                                            key={key}
                                            onChange={(newValue) => handleChange({
                                                target: {
                                                    name: "endDate",
                                                    value: newValue
                                                }
                                            }, index)}
                                            defaultValue={dayjs(currentFormData?.endDate || '')}
                                            minDate={dayjs(currentFormData?.startDate)}
                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid item xs={3}>
                            {!isCurrentCheckedAnywhere || currentFormData.current ? (
                                <FormControlLabel
                                    control={<Checkbox checked={currentFormData?.current} name={"current"}
                                                       data-testid={"current"} onChange={(e) => {
                                        handleChange(e, index)
                                    }} sx={{
                                        color: "#FF6600",
                                        '&.Mui-checked': {
                                            color: "#FF6600",
                                        },
                                    }}/>}
                                    label="Current?"
                                    labelPlacement="end"
                                    sx={{
                                        marginTop: 1,
                                    }}
                                />) : null}
                        </Grid>
                        <Grid item xs={3}>

                        </Grid>

                        <Grid item xs={8}>
                            <TextField
                                style={{width: '99%'}}
                                sx={style}
                                select
                                label="Working model"
                                required
                                variant={readOnly ? "standard" : "outlined"}
                                error={userHasClickedNext && !currentFormData.workModel}
                                name="workModel"
                                value={currentFormData?.workModel || ''}
                                onChange={e => handleChange(e, index)}
                            >
                                {WorkModel.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>

                        <Grid item xs={8}>
                            <TextField
                                sx={style}
                                style={{width: '99%'}}
                                select
                                label="Employment type"
                                name="employmentType"
                                variant={readOnly ? "standard" : "outlined"}
                                required
                                error={userHasClickedNext && !currentFormData.employmentType}
                                data-testid="employmentType"
                                value={currentFormData?.employmentType || ''}
                                onChange={e => handleChange(e, index)}
                            >
                                {EmploymentType.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>

                        <Grid item xs={8}>
                            <TextField
                                sx={style}
                                style={{width: '99%'}}
                                select
                                label="Industry type"
                                variant={readOnly ? "standard" : "outlined"}
                                required
                                error={userHasClickedNext && !currentFormData.industryType}
                                name="industryType"
                                value={currentFormData?.industryType || ''}
                                onChange={e => handleChange(e, index)}
                            >
                                {IndustryType.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>

                        <Grid item xs={8}>
                            <TextField
                                sx={style}
                                style={{width: '99%'}}
                                label="Technologies used"
                                name="technologiesUsed"
                                required
                                variant={readOnly ? "standard" : "outlined"}
                                error={userHasClickedNext && !currentFormData.technologiesUsed}
                                value={currentFormData?.technologiesUsed || ''}
                                data-testid="technologiesUsed"
                                onChange={e => handleChange(e, index)}
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>

                        <Grid item xs={8}>
                            <TextField
                                style={{width: '99%'}}
                                sx={style}
                                select
                                label="Country"
                                name="country"
                                variant={readOnly ? "standard" : "outlined"}
                                required
                                error={userHasClickedNext && !currentFormData.country}
                                value={currentFormData?.country || ''}
                                data-testid="selected-country"
                                onChange={e => handleChange(e, index)}>
                                {Countries.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>

                        <Grid item xs={8}>
                            <FormControl style={{ width: '99%' }} sx={style}>
                                <GoogleMapsAutocomplete
                                    required
                                    fullWidth
                                    label="City"
                                    value={currentFormData?.city ? currentFormData.city : ''}
                                    onPlaceSelected={(formattedLocation) => handlePlaceSelected(formattedLocation, index)}
                                    readOnly={readOnly}
                                    errorText="City is required."
                                    multiple={false}
                                    data-testid="selected-city"
                                    isValid={(!userHasClickedNext || currentFormData.city)}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}/>
                    </Grid>)
                })}

                <Grid container direction={"row"} padding={2} spacing={2} display={"flex"} justifyContent={"flex-start"}
                      alignItems={"flex-end"}>
                    <Grid item xs={1.5}>
                        <Button data-testid={"add"} hidden={readOnly} onClick={addExperience} variant="outlined" style={{
                            width: '89px',
                            height: '40px',
                            fontFamily: 'Poppins',
                            color: '#FF6600',
                            borderColor: '#FF6600'
                        }}>Add</Button>
                    </Grid>
                    <Grid item xs={1.5}>

                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}